import { get } from 'lodash';
import { REQUESTER_OPTIONS_DEFAULTS } from '../enums';

export const parseAgency = requesterAgency => {
  return {
    requesterAgencyId: get(requesterAgency, 'id', null),
    name: get(requesterAgency, 'entity.name', ''),
    billToFacilityPayer: get(requesterAgency, 'billToFacilityPayer'),
    requesterAgencyGroup: get(requesterAgency, 'requesterAgencyGroup', {}),
    ...REQUESTER_OPTIONS_DEFAULTS,
    ...get(requesterAgency, 'requesterOptions', {}),
    payer: get(requesterAgency, 'payers[0]'),
  };
};
